<template>
  <div class="container">
    <img class="wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/guitar-wow.png"/>
    <img class="top-title" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/rank/rank-banner.png"/>
    <div class="back-btn" @click="toPage(0)">
      <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png"/>
      <span>返回首页</span>
    </div>
    <div class="center-wrap">
      <div class="my-data">
        <div class="common-card">
          <div class="avatar">
            <img :src="myData.avatar"/>
            <p>NO.{{ myData.rank }}</p>
          </div>
          <p class="name">{{ myData.name }}</p>
          <p class="me">自己</p>
          <p class="time">{{myData.time}}秒</p>
        </div>
      </div>
      <div class="rank-wrap">
        <div class="top-list">
          <div class="item" v-for="item in topList" :key="item.id">
            <div class="avatar">
              <img :src="item.avatar"/>
              <p>NO.{{ item.rank }}</p>
            </div>
            <p class="time">
              {{ item.name }}<br/>
              {{ item.time }}秒
            </p>
          </div>
        </div>
        <div class="middle-list">
          <div class="common-card" v-for="item in middleList" :key="item.id">
            <div class="avatar">
              <img :src="item.avatar"/>
              <p>NO.{{ item.rank }}</p>
            </div>
            <p class="name">{{ item.name }}</p>
            <!-- <p class="me" v-if="item.me">自己</p> -->
            <p class="time">{{item.time}}秒</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:['pageStep','puzzleId'],
  data(){
    return {
      myData:{
        name:'',
        avatar:'',
        time:'',
        rank:0
      },
      topList:[],
      middleList:[]
    }
  },
  watch:{
    pageStep(n){
      if(n===3){
        this.getRankData();
      }
    }
  },
  created(){
    this.getRankData();
  },
  methods:{
    getRankData(){
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      let userCache = localStorage.getItem('mobile_musicwow_app_wx_user');
      let uid = JSON.parse(userCache).user_id||0;
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/rank_list?puzzle_id=${this.puzzleId}`,
        method: "get",
      }).then((res)=>{
        if(res.data.error_code===0){
          this.myData = {
            name:res.data.data.self.user.nickname,
            avatar:res.data.data.self.user.avatar_url,
            time:res.data.data.self.score/1000,
            rank:res.data.data.self.rank
          }
          let top = [];
          if(res.data.data.list.length>1){
            top = [res.data.data.list[1],res.data.data.list[0]];
          }
          if(res.data.data.list[2]){
            top.push(res.data.data.list[2]);
          }
          let middle = res.data.data.list.slice(3);
          this.topList = top.map((item)=>{
            return {
              id:item.user.user_id,
              avatar:item.user.avatar_url,
              name:item.user.nickname,
              time:item.score/1000,
              rank:item.rank,
            };
          });
          this.middleList = middle.map((item)=>{
            return {
              id:item.user.user_id,
              avatar:item.user.avatar_url,
              name:item.user.nickname,
              time:item.score/1000,
              rank:item.rank,
              me:uid === item.user.user_id
            };
          });
        }else{
          this.$toast(res.data.message);
        }
      });
    },
    toPage(i){
      this.$emit('update:pageStep',i);
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/bg.png);
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  text-align: center;
  overflow: hidden;
}
.back-btn{
  position: fixed;
  top:14px;
  right:10px;
  display: flex;
  align-items: center;
  z-index: 100;
  img{
    width: 40px;
    height: 40px;
  }
  span{
    font-size: 16px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    margin-left: 8px;
  }
}
.wow{
  position: absolute;
  top:10px;
  width: 123px;
  height: auto;
  z-index: 100;
  left:0;
  right:0;
  margin: 0 auto;
}
.top-title{
  position: absolute;
  width: 304px;
  height: auto;
  z-index: 101;
  top: 98px;
  left:0;
  right:0;
  margin: 0 auto;
}
.center-wrap{
  position: absolute;
  top: 148px;
  left: 18px;
  right:18px;
  bottom:24px;
  background: rgba(0, 78, 44, 0.55);
  border: 2px solid rgba(255, 255, 255, 1);
  padding:49px 20px 12px 20px;
  border-radius: 30px;
  overflow: hidden auto;
}
.my-data{
  margin: 0 20px 12px 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #fff;
}
.common-card{
  display: flex;
  text-align: left;
  align-items: center;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 28px;
  padding:6px;
  .avatar{
    position: relative;
    img{
      border-radius: 50%;
      border:2px solid #fff;
      width: 33px;
      height: 33px;
    }
    p{
      position: absolute;
      left:50%;
      transform: translate(-50%,0);
      bottom:-12px;
      font-size: 12px;
      background: rgba(139, 209, 0, 1);
      color:#fff;
      padding:4px 6px;
      border-radius: 6px;
    }
  }
  .name{
    font-size: 13px;
    color:#fff;
    margin:0 12px;
  }
  .me{
    border-radius: 6px;
    color: rgba(250, 222, 66, 1);
    font-size: 12px;
    border: 1px solid rgba(250, 222, 66, 1);
    padding:1px 6px;
  }
  .time{
    text-align: right;
    flex: 1;
    font-size: 13px;
    color:#fff;
    margin-right: 10px;
  }
}
.rank-wrap{
  .top-list{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .item{
      text-align: center;
      width: 80px;
      margin:0 2px;
      position: relative;
      &:nth-child(1){
        .avatar{
          p{
            background: rgba(254, 119, 45, 1);
          }
        }
        &::after{
          content:'';
          position: absolute;
          top:56px;
          left:5px;
          width: 68px;
          height: 25px;
          border-radius: 100%;
          background: linear-gradient(180deg, rgba(254, 119, 45, 0.04) 0%, rgba(254, 119, 45, 1) 100%);
        }
      }
      &:nth-child(2){
        .avatar{
          p{
            background: rgba(255, 178, 0, 1);
          }
        }
        .time{
          padding-bottom: 48px;
        }
        &::after{
          content:'';
          position: absolute;
          top:56px;
          left:5px;
          width: 68px;
          height: 25px;
          border-radius: 100%;
          background: linear-gradient(180deg, rgba(254, 240, 45, 0.04) 0%, rgba(255, 178, 0, 1) 100%);
        }
      }
      &:nth-child(3){
        .avatar{
          p{
            background: rgba(64, 118, 220, 1);
          }
        }
        &::after{
          content:'';
          position: absolute;
          top:56px;
          left:5px;
          width: 68px;
          height: 25px;
          border-radius: 100%;
          background: linear-gradient(180deg, rgba(109, 181, 241, 0.33) 0%, rgba(72, 167, 246, 0.89) 100%);
        }
      }
      .avatar{
        position: relative;
        img{
          width: 55px;
          height: 55px;
          border-radius: 50%;
          border:2px solid #fff;
        }
        p{
          z-index: 10;
          position: absolute;
          left:50%;
          transform: translate(-50%,0);
          bottom:-8px;
          color: #fff;
          padding:4px 8px;
          border-radius: 6px;
        }
      }
      .time{
        flex: 1;
        font-size: 12px;
        color:#fff;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.69) 100%);
        padding-top: 30px;
        padding-bottom: 20px;
      }
    }
  }
  .middle-list{
    border-radius: 20px;
    background: rgba(43, 106, 68, 1);
    border: 2px solid rgba(255, 255, 255, 0.4);
    padding: 18px 28px;
    .common-card{
      margin-bottom: 22px;
    }
  }
}
</style>